module.exports = __webpack_public_path__ + "img/ios_logo.32a4bc61.png";